import BaseApi from './BaseApi'

class AdviserStatusCodesApi extends BaseApi {
  get adviserStatusCodeUrl () {
    return 'adviserStatusCodes'
  }

  getAdviserStatusCodes () {
    return this.getJson(this.adviserStatusCodeUrl)
  }
}

export default AdviserStatusCodesApi
